<div class="custom-header-group">
    <span>{{ params?.displayName }}</span>
</div>